export default __webpack_public_path__ + "static/media/Park.46f7d116.svg";